import React from 'react';
import {ListConfigNamedColumn} from '@src/@types/components/List';
import ListColumn from './ListColumn';
import {IListConfigDateColumn} from '@src/@interfaces/components/List/IListConfigDateColumn';
import {IEmptyModel} from '@src/@interfaces/IEmptyModel';
import ListTruncatedValue from '@src/components/List/ListTruncatedValue';
import {Optional} from '@src/@types/Optional';

export default class TextColumn<
        Model extends IEmptyModel = IEmptyModel
> extends ListColumn<ListConfigNamedColumn<IListConfigDateColumn>, Model> {
    protected baseValueProcessor!: (value: any) => any;

    constructor(props: any) {
        super(props);

        this.baseValueProcessor = super.processValue.bind(this);
    }

    protected processValue(value: any): any {
        value = TextColumn.truncateValue(value, {
            truncateTo: this.props.config.truncate,
            controllerName: this.props.controllerName,
            modelId: this.props.model.id,
            columnName: this.props.config.name,
            valueProcessor: this.baseValueProcessor,
        });

        return super.processValue(value);
    }

    static truncateValue(
            value: any,
            props: Optional<Omit<React.ComponentProps<typeof ListTruncatedValue>, 'truncatedString'>>,
    ) {
        if (
                props.controllerName != null &&
                props.truncateTo != null &&
                props.modelId != null &&
                props.columnName != null &&
                value != null &&
                typeof value === 'string'
        ) {
            return <ListTruncatedValue
                    {...props}
                    truncatedString={value}
                    truncateTo={props.truncateTo}
                    controllerName={props.controllerName}
                    columnName={props.columnName}
                    modelId={props.modelId}
            />;
        }

        return value;
    }
}
